import { DeviceService } from '@/services/device.service'
import _ from 'lodash'
export default {
  methods: {
    async inTicket(id) {
      this.loading = true
      try {
        const res = await DeviceService.detailTransferWarehouse(id)
        const data = res.data
        const devicesGroup = _.groupBy(res.data.devices, 'categoryName')
        data.devicesGroup = Object.values(devicesGroup)
        data.timeImport = data.orderHistories.find(s => s.status === 'SUCCESS')?.dateCreate ?? 0
        await DeviceService.inTransferTicket({ data })
      } catch (error) {
      } finally {
        this.loading = false
      }
    },
    detailItem(id) {
      const routeData = this.$router.resolve({
        path: `/transfer-warehouse/detail/${id}`,
      })
      window.open(routeData.href, '_blank')
    },
    approveCencelItem(item) {
      const h = this.$createElement
      const messageVNode = h(
        'p',
        { class: 'f14' },
        `Bạn có chắc chắn muốn huỷ phiếu thu ${item?.receiptCode} không?`
      )
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Lưu ý',
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true,
        })
        .then(async value => {
          if (value) {
            this.loading = true
            const res = await DeviceService.cancelReceipt({
              receiptId: item.id,
              action: 'CANCEL',
            })
            this.loading = false
            if (res.code === 1000) {
              this.showSuccess(`Huỷ phiếu thu ${item?.receiptCode} thành công`)
              this.fetchData()
            } else this.showErr(res.message)
          }
        })
        .catch(() => {
          this.loading = false
          this.showErr(`Huỷ phiếu thu ${item?.receiptCode} thất bại`)
        })
    },
    approvePending(item) {
      const h = this.$createElement
      const messageVNode = h(
        'p',
        { class: 'f14' },
        `Bạn có chắc chắn muốn chuyển chờ duyệt phiếu thu ${item?.receiptCode} không?`
      )
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Lưu ý',
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true,
        })
        .then(async value => {
          if (value) {
            this.loading = true
            const res = await DeviceService.cancelReceipt({
              receiptId: item.id,
              action: 'PENDING_SA_APPROVAL',
            })
            this.loading = false
            if (res.code === 1000) {
              this.showSuccess(`Chuyển chờ duyệt phiếu thu ${item?.receiptCode} thành công`)
              this.fetchData()
            } else this.showErr(res.message)
          }
        })
        .catch(() => {
          this.loading = false
          this.showErr(`Chuyển chờ duyệt  phiếu thu ${item?.receiptCode} thất bại`)
        })
    },
    approveItemAgent(item, status, title = '') {
      const h = this.$createElement
      const messageVNode = h('p', { class: 'f14' }, `${title} ?` || 'Xác nhận')
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Lưu ý',
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true,
        })
        .then(async value => {
          if (value) {
            this.loading = true
            const res = await DeviceService.changeSTTReceipt({
              receiptId: item.id,
              status: status,
            })
            this.loading = false
            if (res.code === 1000) {
              this.showSuccess(`Thành công`)
              this.fetchData()
            } else this.showErr(res.message)
          }
        })
        .catch(() => {
          this.loading = false
          this.showErr(`${title} thất bại`)
        })
    },
    approveItemSA(item) {
      const h = this.$createElement
      const messageVNode = h(
        'p',
        { class: 'f14' },
        `Bạn có chắc chắn muốn duyệt phiếu thu ${item?.receiptCode} không?`
      )
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Lưu ý',
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true,
        })
        .then(async value => {
          if (value) {
            this.loading = true
            const res = await DeviceService.rejectReceipt({
              receiptId: item.id,
              action: 'PENDING_ACCOUNTANT_APPROVAL',
            })
            this.loading = false
            if (res.code === 1000) {
              this.showSuccess(`Duyệt phiếu thu ${item?.receiptCode} thành công`)
              this.fetchData()
            } else this.showErr(res.message)
          }
        })
        .catch(() => {
          this.loading = false
          this.showErr(`Duyệt phiếu thu ${item?.receiptCode} thất bại`)
        })
    },
    approveItem(item) {
      const h = this.$createElement
      const messageVNode = h(
        'p',
        { class: 'f14' },
        `Bạn có chắc chắn muốn duyệt phiếu thu ${item?.receiptCode} không?`
      )
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Lưu ý',
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true,
        })
        .then(async value => {
          if (value) {
            this.loading = true
            const res = await DeviceService.editCodeReceipt({
              receiptId: item.id,
              action: 'DONE',
            })
            this.loading = false
            if (res.code === 1000) {
              this.showSuccess(`Duyệt phiếu thu ${item?.receiptCode} thành công`)
              this.fetchData()
            } else this.showErr(res.message)
          }
        })
        .catch(() => {
          this.loading = false
          this.showErr(`Duyệt phiếu thu ${item?.receiptCode} thất bại`)
        })
    },
    rejectItem(item) {
      const h = this.$createElement
      const messageVNode = h('div', { class: 'form-group pos-relative' }, [
        h('textarea', { ref: 'rejectValue', class: 'form-control f12' }),
      ])
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Từ chối phiếu thu đại lý',
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true,
          okDisabled: false,
        })
        .then(async value => {
          if (value) {
            this.loading = true
            const res = await DeviceService.editCodeReceipt({
              receiptId: item.id,
              action: 'ACCOUNTANT_REJECTED',
              reasonRejected: this.$refs.rejectValue.value,
            })
            this.loading = false
            if (res.code === 1000) {
              this.showSuccess(`Từ chối phiếu thu ${item?.receiptCode} thành công`)
              this.fetchData()
            } else this.showErr(res.message)
          }
        })
        .catch(() => {
          this.showErr(`Từ chối phiếu thu ${item?.receiptCode} thất bại`)
          this.loading = false
        })
    },
    rejectItemSA(item) {
      const h = this.$createElement
      const messageVNode = h('div', { class: 'form-group pos-relative' }, [
        h('textarea', { ref: 'rejectValue', class: 'form-control f12' }),
      ])
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Từ chối phiếu thu đại lý',
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true,
          okDisabled: false,
        })
        .then(async value => {
          if (value) {
            this.loading = true
            const res = await DeviceService.rejectReceipt({
              receiptId: item.id,

              action: 'SA_REJECTED',
              reasonRejected: this.$refs.rejectValue.value,
            })
            this.loading = false
            if (res.code === 1000) {
              this.showSuccess(`Từ chối phiếu thu ${item?.receiptCode} thành công`)
              this.fetchData()
            } else this.showErr(res.message)
          }
        })
        .catch(() => {
          this.showErr(`Từ chối phiếu thu ${item?.receiptCode} thất bại`)
          this.loading = false
        })
    },
    editReceiptCode(item) {
      const h = this.$createElement
      const messageVNode = h('div', { class: 'form-group pos-relative' }, [
        h('textarea', { ref: 'rejectValue', class: 'form-control f12' }),
      ])
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Sửa mã giao dịch',
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true,
          okDisabled: false,
        })
        .then(async value => {
          if (value) {
            this.loading = true
            const res = await DeviceService.editCodeReceipt({
              receiptId: item.id,
              action: 'CHANGE_TRANSACTION_CODE',
              transactionCode: this.$refs.rejectValue.value,
            })
            this.loading = false
            if (res.code === 1000) {
              this.showSuccess(`Sửa mã giao dịch ${item?.receiptCode} thành công`)
              this.fetchData()
            } else this.showErr(res.message)
          }
        })
        .catch(() => {
          this.showErr(`Sửa mã giao dịch ${item?.receiptCode} thất bại`)
          this.loading = false
        })
    },

    cancelMoving(item, reasonReject) {
      const h = this.$createElement
      const messageVNode = h(
        'p',
        { class: 'f14' },
        `Bạn có chắc chắn xác nhận không nhận hàng cho ${item.quantityExport} thiết bị trong phiếu điều chuyển ${item.billNumber} không?`
      )
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Lưu ý',
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true,
        })
        .then(async value => {
          if (value) {
            this.loading = true
            const res = await DeviceService.cancelMovingTransferWarehouse({
              id: item.id,
              reasonReject: reasonReject,
            })
            this.loading = false
            if (res.code === 1000) {
              this.keyCheck = 'accept'
              this.showSuccess(`Xác nhận không nhận hàng cho phiếu ${item.billNumber} thành công`)
              this.reasonReject = ''
              this.fetchData()
            } else {
              this.keyCheck = 'cancel'
              this.showErr(res.message)
            }
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
